const isEmpty = value => {
  // function 只会返回false
  if (!value) {
    // 若为可隐式转换为false的值，全部返回true
    // 包括 0, '', false
    return true;
  } else {
    return typeof value === 'object' && Object.keys(value).length === 0;
  }
};

export default isEmpty;

/**
 * 判断是否为空对象
 * @param obj
 * @returns
 */
export const isEmptyObject = (obj: { [key: string]: any } | undefined | null) => {
  if (obj === null || obj === undefined || obj.constructor !== Object || Object.keys(obj).length < 1) {
    return true;
  }
  return false;
};
